import { djangoClientQueryFactory } from "api/client/helpers/queryFactory";
import assert from "assert";
import { SerializedSideEffects } from "pages/gdt/store/SideEffects";

export const workflowTableRowCreateRows = djangoClientQueryFactory(
  { method: "post", path: "/library/workflow_table_row/bulk/" },
  {
    formatInput: ({
      table_id,
      row_ids,
      side_effects,
    }: {
      table_id: string;
      row_ids: string[];
      side_effects: SerializedSideEffects;
    }) => {
      return {
        body: {
          row_ids,
          side_effects,
          table_id,
        },
      };
    },
    handleResponse: (res) => {
      const created = res.data;

      assert(
        created !== undefined,
        "Expected data to be defined when creating rows",
      );
      return created;
    },
  },
);
